module.exports = {"address":null,"unit":null,"city":null,"state":null,"zipCode":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/utils/address/resources/model.json
// module id = 0xkp
// module chunks = 1